import React, { lazy, Suspense, useContext, useState } from 'react';
import { BrowserRouter, Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { ThemeProvider, StyledEngineProvider } from '@mui/material/styles';

import Snackbar from '@mui/material/Snackbar';
import Context, { Context as AppContext } from './context/Context';
import { AxiosProvider } from './context/AxiosContext';
import theme from './theme';
import 'react-perfect-scrollbar/dist/css/styles.css';
import './assets/scss/index.scss';
import PublicRoutes from './PublicRoutes';
import AuthenticatedLoadingScreen from './components/AuthenticatedLoadingScreen';
import SnackBarsComponent from './components/SnackBarsComponent';
import {
  FiltersProvider,
  IntelligenceProvider,
  OptionsProvider,
} from 'context';
// import ErrorView from 'ErrorView';

const browserHistory = createBrowserHistory();
const AuthenticatedRoutes = lazy(() => import('./AuthenticatedRoutes'));

const AppRoutes = () => {
  const { token } = useContext(AppContext);

  if (!token) {
    return <PublicRoutes />;
  }

  return (
    <Suspense fallback={<AuthenticatedLoadingScreen />}>
      <AuthenticatedRoutes />
    </Suspense>
  );
};

const App = () => {
  const [errorState, setErrorState] = useState(false);
  const [errorMessageState, setErrorMessageState] = useState('');

  const handleCloseSnackBarsComponent = () => {
    setErrorState(false);
    setErrorMessageState('');
  };

  return (
    <Context.Provider>
      <AxiosProvider>
        <FiltersProvider>
          <OptionsProvider>
            <IntelligenceProvider>
              <BrowserRouter>
                <React.Fragment>
                  <StyledEngineProvider injectFirst>
                    <ThemeProvider theme={theme}>
                      <Router history={browserHistory}>
                        <AppRoutes />

                        {errorState && (
                          <Snackbar
                            anchorOrigin={{
                              vertical: 'bottom',
                              horizontal: 'center',
                            }}
                            open={errorState}
                            onClose={() => setErrorState(false)}
                            autoHideDuration={4500}
                            key={Math.random()}
                          >
                            <SnackBarsComponent
                              variant='error'
                              message={errorMessageState}
                              handleClose={handleCloseSnackBarsComponent}
                            />
                          </Snackbar>
                        )}
                      </Router>
                    </ThemeProvider>
                  </StyledEngineProvider>
                </React.Fragment>
              </BrowserRouter>
            </IntelligenceProvider>
          </OptionsProvider>
        </FiltersProvider>
      </AxiosProvider>
    </Context.Provider>
  );
};
export default App;
